module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('span', {
    staticClass: "title-text",
    staticStyle: {
      "margin": "10px 0 0 25px"
    }
  }, [_vm._v("送样指南")]), _vm._v(" "), (_vm.sampleDeliveryInfo && _vm.sampleDeliveryInfo.length > 0) ? _c('div', [_vm._l((_vm.sampleDeliveryInfo), function(initFile, index) {
    return _c('div', {
      attrs: {
        "id": index
      }
    }, [_c('div', {
      staticClass: "file-content",
      on: {
        "click": function($event) {
          return _vm.downSampleInfoFile(initFile)
        }
      }
    }, [_c('div', {
      staticClass: "layer1"
    }, [_c('img', {
      staticClass: "word-icon",
      attrs: {
        "src": _vm.emkt.getOrderMaterialFileShowIcon(initFile.fileName)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "layer2 flex-col"
    }, [_c('span', {
      staticClass: "file-font"
    }, [_vm._v(_vm._s(initFile.fileName))]), _vm._v(" "), _c('span', {
      staticClass: "file-font",
      staticStyle: {
        "margin-top": "2px"
      }
    }, [_vm._v(_vm._s(initFile.fileSizeDisplay))])]), _vm._v(" "), _c('img', {
      staticClass: "right-icon",
      attrs: {
        "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/right.svg'
      }
    })])])])
  }), _vm._v(" "), _c('span', {
    staticClass: "word",
    staticStyle: {
      "margin": "5px 15px 0px 15px"
    }
  }, [_vm._v("请务必仔细阅读《物品寄送指南》并按照指南收集样本")])], 2) : _c('div', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_c('span', {
    staticClass: "word",
    staticStyle: {
      "color": "#FE654D"
    }
  }, [_vm._v(_vm._s(_vm.getMaterialWarning()))])]), _vm._v(" "), _c('div', {
    staticClass: "sample-info-class"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("实物信息表")]), _vm._v(" "), _c('span', {
    staticClass: "show-txt",
    on: {
      "click": _vm.showMaterialSendProcess
    }
  }, [_vm._v("查看实物寄送流程")])]), _vm._v(" "), _vm._l((_vm.sampleInfo), function(initFile, index) {
    return _c('div', {
      attrs: {
        "id": index
      }
    }, [_c('div', {
      staticClass: "file-content",
      on: {
        "click": function($event) {
          return _vm.downSampleInfoFile(initFile)
        }
      }
    }, [_c('div', {
      staticClass: "layer1"
    }, [_c('img', {
      staticClass: "word-icon",
      attrs: {
        "src": _vm.emkt.getOrderMaterialFileShowIcon(initFile.fileName)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "layer2 flex-col"
    }, [_c('span', {
      staticClass: "file-font"
    }, [_vm._v(_vm._s(initFile.fileName))]), _vm._v(" "), _c('span', {
      staticClass: "file-font",
      staticStyle: {
        "margin-top": "2px"
      }
    }, [_vm._v(_vm._s(initFile.fileSizeDisplay))])]), _vm._v(" "), _c('img', {
      staticClass: "right-icon",
      attrs: {
        "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/right.svg'
      }
    })])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-info-class"
  }, [_c('span', {
    staticClass: "word"
  }, [_vm._v("请完整填写《实物信息表》全部相关信息，寄送实物，将文档直接上传，字迹清晰可辨。推荐在电脑端使用小程序完成上传操作。")]), _vm._v(" "), _c('span', {
    staticClass: "word8",
    on: {
      "click": _vm.showMiniProgramInComputerUsage
    }
  }, [_vm._v("查看小程序在电脑端的使用方法")])]), _vm._v(" "), _c('div', {
    staticClass: "sample-delivery-record"
  }, [_c('span', {
    staticClass: "info4"
  }, [_vm._v("寄送记录")]), _vm._v(" "), _c('span', {
    staticClass: "show-txt",
    on: {
      "click": _vm.showSampleDeliverySheet
    }
  }, [_vm._v("查看寄送记录")])]), _vm._v(" "), _vm._l((_vm.materialDetail.orderMaterialExpressList), function(materialExpress, index) {
    return _c('div', {
      attrs: {
        "id": index
      }
    }, [_c('div', {
      staticClass: "group1 flex-col"
    }, [_c('div', {
      staticClass: "flex-col"
    }, [_c('div', {
      staticClass: "group2 flex-row"
    }, [(materialExpress.expressNo !== '') ? _c('span', {
      staticClass: "express"
    }, [_vm._v("快递单号：" + _vm._s(materialExpress.expressNo))]) : _c('span', {
      staticClass: "express"
    }, [_vm._v("快递单号：待填写")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "9px"
      }
    }, [_c('display-icon-and-status', {
      attrs: {
        "displayStatusName": materialExpress.displayStatusName,
        "displayType": _vm.emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_NMAE
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "layer3 flex-row"
    }, [_c('display-icon-and-status', {
      attrs: {
        "materialType": _vm.materialDetail.orderMaterial.materialType,
        "displayType": _vm.emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_ICON
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(_vm.materialDetail.orderMaterial.materialDesc))]), _vm._v(" "), _c('span', {
      staticClass: "status"
    }, [_vm._v(_vm._s(materialExpress.expressMaterialDetailList[0].displayStatusName))])], 1), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "create-dt-class"
    }, [_c('span', {
      staticClass: "word",
      staticStyle: {
        "margin": "5px 0 0 15px"
      }
    }, [_vm._v("创建时间：" + _vm._s(materialExpress.createDT))])])])])])
  }), _vm._v(" "), _vm._m(0)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "block"
  }), _vm._v(" "), _c('span', {
    staticClass: "end-txt"
  }, [_vm._v("我是有底线的")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06384b6a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/Material/MaterialDetail.vue
// module id = 1525
// module chunks = 8